import { render, staticRenderFns } from "./heading.vue?vue&type=template&id=647b3501&lang=pug"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports